<app-view-title Title="{{ 'Intellitrailer.SelectAlternative.titleSelectAlternative' | translate: 'Select alternative'}}" [isSoftSplit]="true"></app-view-title>
<div class="view-content centered-view" [style.paddingBottom]="'calc(' + layout.actionAreaHeight + 'px + var(--nav-total))'">
  <div *ngIf="loading" style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 20%;">
    <mat-spinner></mat-spinner>
    <p>{{ 'Intellitrailer.SelectAlternative.txtLoadingData' | translate : 'Getting information...' }}</p>
  </div>

  <div *ngIf="!loading">
    <div style="display: flex; flex-wrap: wrap; color:black;">
      <ng-container *ngIf="myOption">
        <div class="container booking-summary-card" style="background: white; padding:15px; border-radius:25px; margin-bottom:15px;">
          <div class="title-with-divider">
            <div class="title">{{ 'Intellitrailer.SelectAlternative.txtYourSearch' | translate : 'Your search'}}</div>
          </div>
          <ow-booking-alternative class="col-md-4 type-group" [booking]="myOption" [unavailable]="!isMyOptionAvailable" (selected)="book($event)"></ow-booking-alternative>
        </div>
      </ng-container>


      <div *ngFor="let option of availableOptions" class="container booking-summary-card" style="background: white; padding:15px; border-radius:25px; color:black; margin-bottom:15px;">
        <div class="title-with-divider">
          <div class="title">{{ 'Intellitrailer.SelectAlternative.txtNearbyAlternative' | translate : 'Nearby alternative' }}</div>
        </div>
        <ow-booking-alternative class="col-md-4 type-group" [booking]="option" (selected)="book($event)"></ow-booking-alternative>
        <div *ngIf="availableOptions.length == 0" style="width: 100%; color: var(--gray); text-align: center;">{{ 'Intellitrailer.SelectAlternative.txtNoNearbyAlternatives' | translate : 'No nearby alternatives' }}</div>
      </div>

      @if(availableOptions.length == 0){
      <div class="container booking-summary-card" style="background: white; padding:15px; border-radius:25px; color:black; margin-bottom:15px;">
        <div class="title-with-divider">
          <div class="title">{{ 'Intellitrailer.SelectAlternative.txtNearbyAlternative' | translate : 'Nearby alternative' }}</div>
        </div>
        <div *ngIf="availableOptions.length == 0" style="width: 100%; color: var(--gray); text-align: center;">{{ 'Intellitrailer.SelectAlternative.txtNoNearbyAlternatives' | translate : 'No nearby alternatives' }}</div>
      </div>
      }

    </div>

  </div>
  <div class="view-actions white-fade-out-bg" *ngIf="(bookingState && bookingState.booking && bookingState.booking.Id && bookingState.booking.PrimaryObjectTypeId)">
    <button *ngIf="!loading" type="button" mat-raised-button (click)="next()" [disabled]="!bookingState.booking.PrimaryType">{{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}</button>
  </div>
</div>

